import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";

import { configurationsConstants } from "../../../../../constants";
import EventAccordion from "../../../../../shared/components/Accordion/EventAccordion";
import { shutterbDashboardActions } from "../../../../../redux/actions";
import EventRequestDetail from "./EventRequestDetail";

const EventRequestTab = (props) => {
  const { t } = useTranslation("common");

  const [...eventRequets] = props.eventRequests;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [eventIdToDecline, setEventIdToDecline] = useState(null);
  const [expandedAccordion, setExpandedAccordion] = useState(null);
  const [shutterbIdToDecline, setShutterbIdToDecline] = useState(null);
  const [orderItemIdToDecline, setOrderItemIdToDecline] = useState(null);

  useEffect(() => {
    // call action to getThe evenRequests from server and update everything
    props.getEventRequests(props.sbUserId);

    // call action that will call serice to get the user data
    //  eslint-disable-next-line
  }, []);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleReasonSubmit = (event, values, errors) => {
    handleUpdateEventRequest(
      eventIdToDecline,
      orderItemIdToDecline,
      shutterbIdToDecline,
      false,
      values.reason
    );
  };

  const handleUpdateEventRequest = (
    eventId,
    orderItemId,
    userName,
    isActive,
    reason
  ) => {
    const dataObj = {
      Id: props.sbUserId,
      EventId: eventId,
      orderItemId: orderItemId,
      UserName: userName,
      isActive: isActive,
      reason: reason,
    };
    props.updateEventRequest(props.sbUserId, dataObj);
    closeModal();
    closeAllAccordions();
  };

  const handleDeclineEventRequest = (event) => {
    setEventIdToDecline(event?.id);
    setShutterbIdToDecline(event?.user?.userName);
    setOrderItemIdToDecline(event?.orderItemId);
    openModal();
  };

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpandedAccordion(isExpanded ? index : null);
  };

  const closeAllAccordions = () => {
    setExpandedAccordion(null);
  };

  return (
    <div id="accordion" className="px-2">
      {eventRequets.length ? (
        eventRequets?.map((event, index) => {
          return (
            <EventAccordion
              showEventDate
              showUserFirstName
              key={index}
              event={event}
              classes="mui-event-accordion"
              expanded={expandedAccordion === index}
              onChange={handleAccordionChange(index)}
            >
              <EventRequestDetail
                event={event}
                handleAccept={handleUpdateEventRequest}
                handleDecline={handleDeclineEventRequest}
              />
            </EventAccordion>
          );
        })
      ) : (
        <p className="d-flex justify-content-center">
          you have not received any event requests yet.
        </p>
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Reason Modal"
        className="reason-modal"
      >
        <div className="modal-content p-4">
          <>
            <h2>reason</h2>
            <AvForm
              className="w-100"
              onValidSubmit={handleReasonSubmit}
              autoComplete="off"
            >
              <AvField
                name="reason"
                type="textarea"
                rows="8"
                cols="30"
                className="h-50"
                label={<span className="form-label">reason to decline:</span>}
                maxLength={configurationsConstants.TEXTAREA_INPUT_LENGTH}
                validate={{
                  required: {
                    value: true,
                    errorMessage: t("reason_required"),
                  },
                }}
              />
              <div className="d-flex justify-content-center">
                <button type="submit" className="custom-btn mt-3">
                  submit
                </button>
              </div>
            </AvForm>
            <button onClick={closeModal} className="modal-close">
              <img
                src="/images/simpleCrossWhite.svg"
                alt="crossIcon"
                className="modal-close-img"
              />
            </button>
          </>
        </div>
      </Modal>
    </div>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  sbUserId: state.shutterbAuthentication.sbUserId,
  eventRequests: state.shutterbDashboard.events,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getEventRequests: (id) =>
    dispatch(shutterbDashboardActions.eventRequests(id)),
  updateEventRequest: (id, dataObj) =>
    dispatch(shutterbDashboardActions.updateEventRequest(id, dataObj)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EventRequestTab));
